import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core'

import { LoggerService } from './logger.service'

/** @internal */
export enum LoggerFeatureKind {
  TRANSPORT,
}

export interface LoggerFeature {
  kind: LoggerFeatureKind
  providers: Provider[]
}

export function provideLogger(...features: LoggerFeature[]): EnvironmentProviders {
  return makeEnvironmentProviders([LoggerService, ...features.flatMap((feature) => feature.providers)])
}
